import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryBreadcrumb({ categorySlug, articleTitle }: { categorySlug?: string; articleTitle?: string }) {
  const category = categories.find(c => c.slug === categorySlug);

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 text-sm text-foreground-400 flex-wrap">
        <li>
          <Link to="/" className="hover:text-foreground-700 transition-colors">首页</Link>
        </li>
        <li><i className="ri-arrow-right-s-line text-xs"></i></li>
        {categorySlug && (
          <>
            <li>
              <Link
                to={`/category/${categorySlug}`}
                className="hover:text-foreground-700 transition-colors"
              >
                {category?.name || '分类'}
              </Link>
            </li>
            {articleTitle && (
              <>
                <li><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-foreground-600 max-w-[200px] truncate">{articleTitle}</li>
              </>
            )}
          </>
        )}
      </ol>
    </nav>
  );
}

export function SchemaBreadcrumb({ categorySlug, categoryName }: { categorySlug: string; categoryName: string }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://4xhyp.com/' },
      { '@type': 'ListItem', position: 2, name: categoryName, item: `https://4xhyp.com/category/${categorySlug}` },
    ],
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
